<template>
  <DashboardCard
    :title="title"
    :loading="loading"
    :counter="totalGroupedItems"
    @refreshCard="$emit('refreshCard')"
    :showActionIcon="showActionIcon"
    :showCounter="showCounter"
  >
    <v-expansion-panel v-if="items.length" focusable v-model="panel">
      <v-expansion-panel-content
        v-for="item in items"
        :key="item[itemKey]"
        class="expansion-panel"
      >
        <template v-slot:header>
          <div class="body-2">{{ item[itemText] }} ({{item[itemValue]}})</div>
        </template>
        <v-card>
          <v-card-text class="py-0">
            <v-list class="py-0" v-if="item.Items && item.Items.length && !loading">
              <template v-for="(itemChild, i) of item.Items">
                <v-list-tile
                  :key="itemChild[itemChildHeaders[0]]"
                  @click="$router.push({ name: itemRoute, params: { id: itemChild[itemChildHeaders[0]] }})"
                >
                  <v-list-tile-content class="body-1">
                    <v-list-tile-title style="height: 100%;">
                      <v-layout wrap :fill-height="$vuetify.breakpoint.mdAndUp" :column="$vuetify.breakpoint.xsOnly" :align-center="$vuetify.breakpoint.mdAndUp">
                        <v-flex md8 xs12 pb-0>{{ itemChild[itemChildHeaders[1]] }}</v-flex>
                        <v-flex md2 xs12 pb-0>{{ moment(itemChild[itemChildHeaders[2]]).format('DD/MM/YYYY') }}</v-flex>
                        <v-flex class="text-truncate" md2 xs12 pb-0 v-if="itemChild[itemAvatar] && $vuetify.breakpoint.mdAndUp">
                          <v-tooltip
                            v-for="avatar of itemChild[itemAvatar].split(';')"
                            :key="avatar"
                            bottom
                          ><v-chip
                            slot="activator"
                            color="primary"
                            dark
                          >{{ avatar[0] }}
                          </v-chip>
                          <span>{{ avatar }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider
                  v-if="i !== item.Items.length - 1"
                  :key="i + Math.random()"
                  :class="{ 'my-1': $vuetify.breakpoint.xsOnly }"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <div v-else class="body-2 t text-xs-center py-3">Nenhum registro encontrado</div>
  </DashboardCard>
</template>

<script>
import DashboardCard from '@/components/dashboard/DashboardCard';

export default {
  name: 'DashboardCardListGroup',
  props: {
    title: {
      type: String,
      default: 'My Title'
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'Descricao'
    },
    itemValue: {
      type: String,
      default: 'Total'
    },
    itemRoute: {
      type: String,
      default: ''
    },
    itemKey: {
      type: String,
      default: ''
    },
    itemAvatar: {
      type: String,
      default: 'Avatar'
    },
    itemChip: {
      type: String,
      default: 'Chip'
    },
    itemChildHeaders: {
      type: Array,
      default: () => []
    },
    textStyle: {
      type: String,
      default: 'body-2'
    },
    showActionIcon: {
      type: Boolean,
      default: true
    },
    showCounter: {
      type: Boolean,
      default: true
    },
  },
  components: {
    DashboardCard
  },
  data: () => ({
    panel: null
  }),
  watch: {
    panel(index) {
      if (index !== null && !this.items[index].Items) this.$emit('getAtividadesByType', this.items[index][this.itemKey]);
    },
  },
  computed: {
    totalGroupedItems() {
      let total = 0;
      this.items.forEach(item => total += item.Total);
      return total.toString();
    },
  },
  methods: {
    mapChild(item) {
      let itemText = '';
      for (const i in item) {
        isVal
        itemText += item[i] + ' ';
      }
      return itemText;
    },
    itemLink(item) {
      if (item.route) return item.route;

      const link = {
        name: this.itemRoute
      };
      if (this.itemKey) link.params = { id: item[this.itemKey] };
      return link;
    }
  }
}
</script>

<style scoped>
.expansion-panel > :first-child {
  padding-left: 16px;
}
</style>